import React from 'react';
import TabularComparison from "./tabular-comparison";
import {createRoot} from "react-dom/client";

const root = createRoot(document.getElementById('root'));
root.render(<TabularComparison/>);